import { useMatch } from '@reach/router'
import { Instance } from 'mobx-state-tree'
import { IRoot } from 'src/api/stores/Root/types'
import { Side, orbit } from 'src/constants/sides'
import { IEditor } from 'src/api/stores/Editor/types'
import { IPreview } from 'src/api/stores/Preview/types'
import { IConfiguration } from 'src/api/stores/Configuration/types'
import { Typename } from './typenames'

export type Params = {
  projectID: string
}

export const login = 'login'
export const logout = 'logout'

export const projectRoute = 'project'
export const projectsRoute = 'projects'
export const editorRoute = 'editor'
export const configurationRoute = 'setup'
export const summaryRoute = `${configurationRoute}/summary`

export const projectPreviewState = 'preview' as const
export const projectConfigurationState = 'setup' as const
export const projectConfigurationSummaryState = 'summary' as const
export const projectEditorState = 'editor' as const

export const projectStates = [
  projectPreviewState,
  projectConfigurationState,
  projectConfigurationSummaryState,
  projectEditorState
]

/**
 * /:page/:projectID/:state/* <= substate
 * /projects
 *
 */

export type ProjectState = Unpacked<typeof projectStates>

export type RouteState = DefaultRouteState | ConfigurationRouteState | EditorRouteState

export type CommonRouteState = {
  store: Instance<IRoot>
  perceptions?: { [key in Typename]?: { opacity?: number; visible?: boolean } }
}

export type DefaultRouteState = {
  page?: typeof projectsRoute | typeof projectRoute
  view?: undefined
  state?: undefined
} & CommonRouteState

export type ConfigurationRouteState = CommonRouteState & {
  page: typeof projectRoute
  params: { projectID: string }
  state:
    | { name: 'setup'; step?: string; subStep?: string }
    | { name: 'summary'; direction?: 'forward' | 'backward' }
  view: Instance<IConfiguration>
}

export type EditorRouteState = CommonRouteState & {
  page: typeof projectRoute
  params: { projectID: string }
  state: { name: 'editor'; sideview: Side | typeof orbit }
  view: Instance<IEditor>
}

export type PreviewRouteState = CommonRouteState & {
  page: typeof projectRoute
  params: { projectID: string }
  state: { name: 'preview' }
  view: Instance<IPreview>
}
